import { Component, State, Listen, h } from '@stencil/core';
import { isEmpty } from '../utils/is-empty.js';

@Component({
  tag: 'lk-feedback'
})
export class Feedback {
  answer: string;
  description: string;
  @State() display: string = 'answers';
  @State() resetValue: string = "";

  setAnswer(event: UIEvent, value: string) {
    event.preventDefault();

    if (this.display === 'answers') {
      this.resetValue = "";
    }

    this.answer = value;
    this.display = this.answer === 'ja' 
      ? 'feedback-yes' 
      : 'feedback-no';            
  }

  @Listen('formCancel')
  onCancel() {
    this.display = 'answers';
    this.resetValue = null;
    const button = document.getElementById('feedback-button-yes');
    if (!isEmpty(button)){
      button.focus();
    }
    
  }

  @Listen('formSubmit')
  onSubmit(event: CustomEvent) {
    this.description = event.detail !== '' ? event.detail : '';    
    this.display = 'feedback-confirmation';

    let page = ((document.querySelector('input[name=page]') as HTMLInputElement) === null) ? 0 : (document.querySelector('input[name=page]') as HTMLInputElement).value;
    let string = `url=${window.location.href}&page=${page + ''}&answer=${this.answer}&text=${this.description}`;
    let request = new XMLHttpRequest();

    request.open("POST", "/api/feedback", true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');    

    request.onerror = () => {
      alert("En feil har skjedd!")
    };

    request.send(string);
  }

  componentDidRender() {        
    const confirmation = document.getElementById('feedback-confirmation')?.querySelector('h2');
    
    if (!isEmpty(confirmation)) {
      confirmation.focus();
    }

    this.setFeedbackFormTextAreaFocus()
  }

  setFeedbackFormTextAreaFocus() {
    if (this.display === 'feedback-yes') {
      const answer = document.getElementById('description-yes');
      if (!isEmpty(answer)) {
        answer.focus();
      }
    } else if(this.display === 'feedback-no') {
      const answer = document.getElementById('description-no');
      if (!isEmpty(answer)){
        answer.focus()
      }
    }
  }

  render() {
    return (
      <div class="feedback container">
        <fieldset>
          <legend class="small-title">Fant du det du lette etter?</legend>

          <div class="feedback__answers margin-y--medium" id="feedback-answers" style={{ display: this.display === "feedback-confirmation" ? "none" : "flex" }} >
            <button id="feedback-button-yes" type="button" class={`margin-right--medium ${this.display === "feedback-yes" ? 'feedback-button-active' : ''}`} value="ja" onClick={event => { this.setAnswer(event, 'ja'); }}>
              <span class="button__text">Ja</span>
            </button>
            <button id="feedback-button-no" type="button" class={`margin-left--medium ${this.display === "feedback-no" ? 'feedback-button-active' : ''}`} value="nei" onClick={event => { this.setAnswer(event, 'nei'); }}>
              <span class="button__text">Nei</span>
            </button>
          </div>
        </fieldset>

        <div id="feedback-yes" style={{ display: this.display == "feedback-yes" ? "block" : "none" }}>
          <p class="feedback__block">
            <svg aria-hidden="true" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.507 13.941c-1.512 1.195-3.174 1.931-5.506 1.931-2.334 0-3.996-.736-5.508-1.931l-.493.493c1.127 1.72 3.2 3.566 6.001 3.566 2.8 0 4.872-1.846 5.999-3.566l-.493-.493zm-9.007-5.941c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5-.672-1.5-1.5-1.5zm7 0c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5-.672-1.5-1.5-1.5z" /></svg>
            <span>Så bra! Kan du fortelle oss hva du lette etter?</span>
          </p>
          <lk-feedback-form reset-value={this.resetValue} is-positive-feedback="true" descriptive-text="Så bra! Kan du fortelle oss hva du lette etter?"></lk-feedback-form>
        </div>

        <div id="feedback-no" style={{ display: this.display === "feedback-no" ? "block" : "none" }}>
          <p class="feedback__block">
            <svg aria-hidden="true" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm.001 14c-2.332 0-4.145 1.636-5.093 2.797l.471.58c1.286-.819 2.732-1.308 4.622-1.308s3.336.489 4.622 1.308l.471-.58c-.948-1.161-2.761-2.797-5.093-2.797zm-3.501-6c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5-.672-1.5-1.5-1.5zm7 0c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5-.672-1.5-1.5-1.5z" /></svg>
            <span>Ojda, det vil vi gjerne rette opp i, kan du fortelle oss hva du lette etter?</span>
          </p>
          <lk-feedback-form reset-value={this.resetValue} is-positive-feedback="false" descriptive-text="Ojda, det vil vi gjerne rette opp i, kan du fortelle oss hva du lette etter?"></lk-feedback-form>
        </div>

        <div class="padding-top--base" id="feedback-confirmation" style={{ display: this.display === "feedback-confirmation" ? "block" : "none" }}>
          <h2 class="section-title" tabIndex={-1} aria-describedby="confirmation-message">Takk for tilbakemeldingen!</h2>
          <p id="confirmation-message">
            Vi vil bruke svaret du sendte inn til å gjøre nettstedet bedre.
          </p>
        </div>
      </div >
    );
  }
}
